import React, { useEffect, useState } from 'react';

import { Typography, Box } from '@mui/material';

import { CustomPie } from '../../common_components';

import { useStyles } from './../styles';

export const Tokenomics = ({ alloc_details, total_supply }) => {
  const [tokenomicsData, setTokenomicsData] = useState([]);
  const styles = useStyles();

  useEffect(() => {
    const data = alloc_details?.map((item) => ({
      id: item.type,
      label: item.type,
      value: item.alloc_supply,
      allocation_per: item.allocation
    }));
    setTokenomicsData(data);
  }, [alloc_details]);

  return (
    <>
      <Typography variant="h6" gutterBottom component="div" sx={{ textAlign: 'center' }}>
        {`Tokenomics`}
      </Typography>
      <Box className={styles.tokenomicsChart}>
        <CustomPie
          data={tokenomicsData}
          total_supply={total_supply}
          CustomLayerComponent={CenteredMetric}
        />
      </Box>
    </>
  );
};

export const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
  let total = 0;
  dataWithArc.forEach((datum) => {
    total += datum.value;
  });

  return (
    <>
      <text
        x={centerX}
        y={centerY}
        textAnchor="middle"
        dominantBaseline="central"
        style={{
          fontSize: 'clamp(15px, 2.5vw, 25px)',
          fontWeight: 600
        }}>
        {total?.toLocaleString(undefined, { minimumFractionDigits: 0 })}
      </text>
    </>
  );
};
